/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import '../../css/custom-responsive.css';
import '../../css/custom.css';
import { NavLink } from 'react-router-dom';
import { prefixPath } from '../../utils/helpers';
import { AdditionalProtocolInterface } from './marketplaceBody';

interface networkcard extends AdditionalProtocolInterface {
  num: number,
  type: 'dedicated' | 'staking'
}
const CardNetworkNew = ({
  name, description, num, plan_code, type,
}: networkcard) => {
  const setImage = (val: string) => {
    if (val.includes(' ')) {
      // eslint-disable-next-line prefer-destructuring, no-param-reassign
      val = val.replace(/\s/g, '');
    }
    switch (val.toLowerCase()) {
      case 'acala': return 'images/protocols/logos/acala_logo.svg';
      case 'algorand': return 'images/protocols/logos/algorand_logo.svg';
      case 'arbitrum': return 'images/protocols/logos/arbitrum_logo.svg';
      case 'aurora': return 'images/protocols/logos/aurora_logo.svg';
      case 'base': return 'images/protocols/logos/base_logo.svg';
      case 'bitcoin': return 'images/protocols/logos/bitcoin_logo.svg';
      case 'harmony': return 'images/protocols/logos/harmony_logo.svg';
      case 'crossfi': return 'images/protocols/logos/crossfi_logo.png';
      case 'klaytn': return 'images/protocols/logos/klaytn_logo.svg';
      case 'kusama': return 'images/protocols/logos/kusama_logo.svg';
      case 'moonbeam': return 'images/protocols/logos/Moonbeam_logo.svg';
      case 'near': return 'images/protocols/logos/near_logo.svg';
      case 'optimism': return 'images/protocols/logos/optimism_logo.svg';
      case 'tezos': return 'images/protocols/logos/tezos_logo.svg';
      case 'aptos': return 'images/protocols/logos/Aptos_logo.svg';
      case 'arbitrumnova': return 'images/protocols/logos/arbitrum_nova_logo.svg';
      case 'cardano': return 'images/protocols/logos/cardano_logo.svg';
      case 'celo': return 'images/protocols/logos/celo_logo.svg';
      case 'cosmos': return 'images/protocols/logos/cosmos_logo.svg';
      case 'cronos': return 'images/protocols/logos/cronos_logo.svg';
      case 'flow': return 'images/protocols/logos/flow_logo.svg';
      case 'fuse': return 'images/protocols/logos/fuse_logo.svg';
      case 'gnosischain': return 'images/protocols/logos/gnosischain_logo.svg';
      case 'hedera': return 'images/protocols/logos/hedera_logo.svg';
      case 'lisk': return 'images/protocols/logos/lisk_logo.svg';
      case 'nervos': return 'images/protocols/logos/nervos_logo.svg';
      case 'persistence': return 'images/protocols/logos/persistence_logo.svg';
      case 'solana': return 'images/protocols/logos/solana_logo.svg';
      case 'stacks': return 'images/protocols/logos/stacks_logo.svg';
      case 'ton': return 'images/protocols/logos/ton_logo.svg';
      case 'telos': return 'images/protocols/logos/telos_logo.svg';
      case 'xdc': return 'images/protocols/logos/xdc_logo.svg';
      case 'binance': return 'images/protocols/logos/binance_logo.svg';
      case 'okc': return 'images/protocols/logos/okc_logo.svg';
      case 'polygon': return 'images/protocols/logos/Polygonpos_logo.svg';
      case 'fantom': return 'images/protocols/logos/Fantom_logo.svg';
      case 'tron': return 'images/protocols/logos/tron_logo.svg';
      case 'ethereum': return 'images/protocols/logos/ethereum_logo.svg';
      case 'zkevm': return 'images/protocols/logos/zkevm_logo.svg';
      case 'starknet': return 'images/protocols/logos/starknet_logo.png';
      case 'provenanceblockchain': return 'images/protocols/logos/provenance_blockchain_logo.svg';
      case 'bahamut': return 'images/protocols/logos/fastex_logo.svg';
      case 'zksyncera': return 'images/protocols/logos/zksyncera_logo.svg';
      case 'opstack': return 'images/protocols/logos/opstack_logo.svg';
      case 'arbitrumorbit': return 'images/protocols/logos/arbitrum_orbit_logo.svg';

      default: return '';
    }
  };
  const showLess = (des: string, id: string, sid1: string, sid2: string) => {
    const ptag: HTMLElement | null = document.getElementById(id);
    const spanTag1: HTMLElement | null = document.getElementById(sid1);
    const spanTag2: HTMLElement | null = document.getElementById(sid2);
    if (spanTag1 && spanTag2 && ptag) {
      ptag.innerHTML = `${des.substr(0, Math.min(120, des.length))}   ...`;
      ptag.style.height = '95px';
      spanTag1.style.display = 'block';
      spanTag2.style.display = 'none';
    }
  };
  const showMore = (des: string, id: string, sid1: string, sid2: string) => {
    const ptag: HTMLElement | null = document.getElementById(id);
    const spanTag1: HTMLElement | null = document.getElementById(sid1);
    const spanTag2: HTMLElement | null = document.getElementById(sid2);

    if (ptag && spanTag1 && spanTag2) {
      ptag.innerHTML = des;
      ptag.style.height = '230px';
      spanTag1.style.display = 'none';
      spanTag2.style.display = 'block';
    }
  };

  const getUrl = () => {
    if (window.location.href.indexOf('staking-nodes') > -1) {
      return prefixPath(`/protocol/purchase/staking-nodes?name=${name}&plan_code=${plan_code}`);
    }
    return prefixPath(`/protocol/purchase/dedicated-nodes?name=${name}&plan_code=${plan_code}`);
  };

  return (
    <div style={{ display: name.toLowerCase() === 'phaeton' ? 'none' : 'block' }} className="col-xl-4 effectCard cursor mt-4 col-lg-4 col-md-12 col-sm-12">

      <div className="card">
        <NavLink to={getUrl()} className="nonActiveTextColor" style={{ textDecoration: 'none' }}>
          <div className="card-body text-center mt-2 mb-2">
            <img src={`${type === 'dedicated' ? './' : '../'}${setImage(name)}`} alt="" height={32} />
          </div>
          <div className="row mt-4 mb-4">
            <div className="col-xl-8 col-7 col-md-4" />
            <span className="col-3 badge text-center">Do it yourself </span>
          </div>
          <div>
            <p
              className="text-muted"
              id={`addtionaldesTag${num}`}
              style={{
                height: '95px', overflowY: 'hidden', textOverflow: 'ellipsis', margin: '0px 15px',
              }}
            >
              {`${description.substr(0, Math.min(120, description.length))}   ...`}
            </p>
          </div>
        </NavLink>
        <div
          className="py-1"
          id={`ap${num}`}
          style={{
            textAlign: 'right', color: '#5B80F0 ', marginTop: '-3%', marginRight: '6px',
          }}
          onClick={() => { showMore(description, `addtionaldesTag${num}`, `ap${num}`, `a${num}`); }}
        >
          &nbsp;
          Read More
        </div>

        <div
          className="py-2"
          id={`a${num}`}
          style={{
            textAlign: 'right', color: '#5B80F0 ', display: 'none', marginRight: '12px',
          }}
          onClick={() => { showLess(description, `addtionaldesTag${num}`, `ap${num}`, `a${num}`); }}
        >
          &nbsp;
          Read Less
        </div>

        <div className="card-footer mt-1">
          <NavLink to={getUrl()} className="nonActiveTextColor" style={{ textDecoration: 'none' }}>
            <div className="d-flex mt-1">
              <div className="col-6">
                <p className="mb-1 text-muted">{name}</p>
              </div>
              <div className="col-6 d-flex justify-content-end cursor">
                <div className="form-check" />
              </div>
            </div>
          </NavLink>
        </div>

      </div>

    </div>

  );
};
export default CardNetworkNew;
